<script>
import beforeLoginCommentInput from './index'
export default {
  extends: beforeLoginCommentInput,
  props: {
    replyKey: String
  },
  methods: {
    loginHandler () {
      try {
        const comment = {
          comment: this.comment,
          expired_at: new Date().getTime() + 60 * 60 * 1000
        }
        localStorage.setItem(
          `before_reply_${this.replyKey}`,
          JSON.stringify(comment)
        )
      } catch (e) {
        return false
      }
      global.loginModal('newsComment')
    },
    registerHandler () {
      try {
        const comment = {
          comment: this.comment,
          expired_at: new Date().getTime() + 60 * 60 * 1000
        }
        localStorage.setItem(
          `before_reply_${this.replyKey}`,
          JSON.stringify(comment)
        )
      } catch (e) {
        return false
      }
      const url = encodeURI(document.location.href)
      const apiDomain = document.URL.match('dev-www') ? 'dev-id.j-cast.com' : 'id.j-cast.com'
      document.location.href = `https://${apiDomain}/account/register?jrole=r-q7sDbkJB&jorig=NewsComment&jrettxt=5YWD44Gu44Oa44O844K444Gr5oi744KL&jreturl=https%3A%2F%2F${apiDomain}%2Fexternal%2Flogin%3Fsite_id%3Ds-yXnV5AwD%26ret_url%3D${url}`
    },
    addRoleHandler () {
      try {
        const comment = {
          comment: this.comment,
          expired_at: new Date().getTime() + 60 * 60 * 1000
        }
        localStorage.setItem(
          `before_reply_${this.replyKey}`,
          JSON.stringify(comment)
        )
      } catch (e) {
        return false
      }
      global.rankupModal('newsComment')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/organisms/beforeLoginCommentInput/reply.vue